<template>
  <div class="adminhome" style="min-height:85vh; position:relative;">
    <div style="display:flex; flex-wrap:wrap; gap:12px; margin-bottom:16px;">
      <div style="margin: 16px 0; display:flex; align-items:center; gap:16px;">
        <a-breadcrumb>
          <a-breadcrumb-item style="font-size:30px;">Country Content</a-breadcrumb-item>
        </a-breadcrumb>
        <a-button type="primary">
          <router-link to="/admin/country-content/add">Add Country Content</router-link>
        </a-button>
      </div>
      <a-input-search
        placeholder="Search by title or country"
        style="max-width:320px; margin-left:auto;"
        v-model="searchText"
        @search="handleSearch"
        allow-clear
      />
    </div>

    <a-card>
      <a-table
        :loading="loading"
        :data-source="filteredList"
        :row-key="record => record._id"
        :pagination="{ pageSize: 10 }"
        :scroll="{ x: 900 }"
      >
        <a-table-column key="country" title="Country" data-index="countryName" />
        <a-table-column key="title" title="Title" data-index="title" />
        <a-table-column key="slug" title="Slug" data-index="country_slug" />
        <a-table-column key="status" title="Status">
          <template slot-scope="text, record">
            <a-tag :color="record.status === 1 ? 'green' : 'orange'">
              {{ record.status === 1 ? 'Published' : 'Draft' }}
            </a-tag>
          </template>
        </a-table-column>
        <a-table-column key="updatedAt" title="Updated" data-index="updatedAtFormatted" />
        <a-table-column key="actions" title="Actions" :width="200">
          <template slot-scope="text, record">
            <a-button type="link" @click="goToEdit(record)">Edit</a-button>
            <a-divider type="vertical" />
            <a-popconfirm
              title="Are you sure you want to delete this country content?"
              ok-text="Yes"
              cancel-text="No"
              @confirm="handleDelete(record)"
            >
              <a-button type="link" :loading="deletingId === record._id">Delete</a-button>
            </a-popconfirm>
          </template>
        </a-table-column>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import moment from "moment";
import { api } from "../helpers/Helpers";

export default {
  data() {
    return {
      loading: false,
      deletingId: null,
      contentList: [],
      filteredList: [],
      countries: [],
      searchText: "",
    };
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      this.loading = true;
      try {
        const [countryRes, contentRes] = await Promise.all([
          api.getCountryInfo(),
          api.getCountryContents(),
        ]);
        this.countries = Array.isArray(countryRes) ? countryRes : [];
        const enhanced = Array.isArray(contentRes)
          ? contentRes.map((item) => this.decorateContent(item))
          : [];
        this.contentList = enhanced;
        this.filteredList = enhanced;
      } catch (error) {
        console.error(error);
        this.$message.error("Failed to load country content.");
      } finally {
        this.loading = false;
      }
    },
    decorateContent(item) {
      const countryInfo = this.countries.find((c) => c._id === item.country_id);
      return {
        ...item,
        countryName: countryInfo ? countryInfo.country : "—",
        updatedAtFormatted: item.updatedAt ? moment(item.updatedAt).format("MMM DD, YYYY") : "—",
      };
    },
    handleSearch() {
      const term = (this.searchText || "").toLowerCase();
      if (!term) {
        this.filteredList = this.contentList;
        return;
      }
      this.filteredList = this.contentList.filter((item) => {
        return (
          (item.title || "").toLowerCase().includes(term) ||
          (item.countryName || "").toLowerCase().includes(term)
        );
      });
    },
    goToEdit(record) {
      this.$router.push({ path: "/admin/country-content/edit", query: { id: record._id } });
    },
    handleDelete(record) {
      return async () => {
        if (this.deletingId) return;
        this.deletingId = record._id;
        try {
          await api.deleteCountryContent(record._id);
          this.$message.success("Country content deleted.");
          this.contentList = this.contentList.filter((item) => item._id !== record._id);
          this.handleSearch();
        } catch (error) {
          console.error(error);
          this.$message.error("Failed to delete country content.");
        } finally {
          this.deletingId = null;
        }
      };
    },
  },
};
</script>

<style scoped>
.adminhome :deep(.ant-table) {
  overflow-x: auto;
}
</style>
